import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.br';
import TextInput from './TextInput';

export default class MaskInput extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    label: PropTypes.string.isRequired,
    errorText: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    value: PropTypes.any,
    maskType: PropTypes.oneOf(['phone', 'numeral', 'custom']),
    delimiters: PropTypes.arrayOf(PropTypes.string),
    delimiter: PropTypes.string,
    blocks: PropTypes.arrayOf(PropTypes.number),
    numericOnly: PropTypes.bool,
    numeralPositiveOnly: PropTypes.bool,
    numeralDecimalMark: PropTypes.string,
    numeralDecimalScale: PropTypes.number,
    required: PropTypes.bool,
  };

  static defaultProps = {
    value: '',
    disabled: false,
    errorText: null,
    placeholder: null,
    delimiters: [],
    delimiter: null,
    numericOnly: false,
    numeralPositiveOnly: false,
    numeralDecimalScale: 2,
    required: false,
    maskType: 'custom',
    blocks: [],
  };

  state = { maskedValue: '' };

  componentDidMount() {
    this.initMask({
      delimiters: this.props.delimiters,
      blocks: this.props.blocks,
      delimiter: this.props.delimiter,
      numericOnly: this.props.numericOnly,
      numeralPositiveOnly: this.props.numeralPositiveOnly,
      numeralDecimalMark: this.props.numeralDecimalMark,
      numeralDecimalScale: this.props.numeralDecimalScale,
      phoneRegionCode: 'BR',
      onValueChanged: this.handleChange,
      [this.props.maskType]: true,
    });
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (this.maskedField) {
      this.maskedField.setRawValue(nextProps.value);
      this.setState({
        maskedValue: this.maskedField.getFormattedValue(),
      });
    }
  }

  componentWillUnmount() {
    this.maskedField.destroy();
  }

  updateMaskOptions({ delimiters, blocks }) {
    this.maskedField.destroy();
    this.initMask({
      delimiters,
      blocks,
      delimiter: this.props.delimiter,
      numericOnly: this.props.numericOnly,
      numeralPositiveOnly: this.props.numeralPositiveOnly,
      numeralDecimalMark: this.props.numeralDecimalMark,
      numeralDecimalScale: this.props.numeralDecimalScale,
      phoneRegionCode: 'BR',
      onValueChanged: this.handleChange,
      [this.props.maskType]: true,
    });
  }

  initMask(maskOptions) {
    this.maskedField = new Cleave($(ReactDOM.findDOMNode(this.textInput)).find('input'), maskOptions);
    this.maskedField.setRawValue(this.props.value);
    this.setState({
      maskedValue: this.maskedField.getFormattedValue(),
    });
  }

  handleChange = () => {
    if (this.maskedField.getFormattedValue() === this.state.maskedValue) {
      return;
    }

    this.setState(
      {
        maskedValue: this.maskedField.getFormattedValue(),
      },
      () => {
        if (this.props.onChange) {
          this.props.onChange(this.maskedField.getRawValue(), this.maskedField.getFormattedValue());
        }
      }
    );
  };

  render() {
    return (
      <TextInput
        required={this.props.required}
        label={this.props.label}
        value={this.state.maskedValue}
        // onChange={this.handleChange}
        disabled={this.props.disabled}
        placeholder={this.props.placeholder}
        errorText={this.props.errorText}
        type="text"
        ref={(input) => {
          this.textInput = input;
        }}
      />
    );
  }
}
